import React from 'react'
import GermanyBloreMain from './GermanyBloreMain'
import "./../../UaeAttestation/UaeBlore/UaeBlore.css";
import UaeBloreHead from '../../UaeAttestation/UaeBlore/UaeBloreHead';

const GermanyBlore = () => {
  return (
    <div className="uaeBloreContainer">
    <UaeBloreHead head="Germany Apostille in Bangalore" />
    <GermanyBloreMain />
  </div>
  )
}

export default GermanyBlore
